import { createSlice } from "@reduxjs/toolkit";
import { deleteFile } from "./thunks";

interface FilesState {
  deletingIds: number[];
  lastDeletedId: number | null;
  error: string | null;
}

const initialState: FilesState = {
  deletingIds: [],
  lastDeletedId: null,
  error: null,
};

const filesSlice = createSlice({
  name: "files",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteFile.pending, (state, action) => {
        const id = action.meta.arg;
        if (!state.deletingIds.includes(id)) state.deletingIds.push(id);
        state.error = null;
      })
      .addCase(deleteFile.fulfilled, (state, action) => {
        const id: any = action.payload;
        state.deletingIds = state.deletingIds.filter((x) => x !== id);
        state.lastDeletedId = id;
      })
      .addCase(deleteFile.rejected, (state, action) => {
        const id = action.meta.arg;
        state.deletingIds = state.deletingIds.filter((x) => x !== id);
        state.error = action.error?.message || "Erro ao remover arquivo";
      });
  },
});

export default filesSlice.reducer;
